import React, {useState} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import {ProvidersBrowser} from "./shared/providers/ProvidersBrowser";
import {useTranslation} from "react-i18next";
import {ProGroupList} from "./groups/ProGroupList";
import Card from "@material-ui/core/Card";
import {CardContent} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {ArrowBackIos} from "@material-ui/icons";
import {FolderHierarchyBreadcrumbs} from "./shared/folder-hierarchy-breadcrumb/FolderHieararchyBreadcrums";
import {useNavigate} from "react-router-dom";
import {TabPanel} from "../_shared/TabPanel";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(4),
        flexGrow: 1,
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    },
    top: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        alignItems: 'center'
    },
}));


export const ProGuestOverview = ({
                                     organizationId,
                                     folderId,
                                     tab
                                 }: any) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const [currentTab, setCurrentTab] = useState(tab || 0);
    const navigate = useNavigate();

    const handleChange = (event: any, newValue: any) => {
        setCurrentTab(newValue);
    };

    const goBack = () => navigate(-1);

    return <div className={classes.root}>
        <div className={classes.top}>
            <Button onClick={goBack}>
                <ArrowBackIos color="primary"/>
            </Button>
            <FolderHierarchyBreadcrumbs organizationId={organizationId}
                                        folderId={folderId}/>
        </div>
        <Card variant="outlined">
            <CardContent>
                <Tabs value={currentTab} onChange={handleChange} aria-label="pro-guest tabs" indicatorColor="primary">
                    <Tab label={t('ProGuest.Providers.Title')} {...buildTabId(0)} />
                    <Tab label={t('ProGuest.Groups.Title')} {...buildTabId(1)} />
                </Tabs>

                <TabPanel value={currentTab} index={0}>
                    <Box p={3}>
                        <ProvidersBrowser organizationId={organizationId} folderId={folderId}/>
                    </Box>
                </TabPanel>
                <TabPanel value={currentTab} index={1}>
                    <Box p={3}>
                        <ProGroupList organizationId={organizationId} folderId={folderId}/>
                    </Box>
                </TabPanel>
            </CardContent>
        </Card>
    </div>
};

function buildTabId(index: any) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}
